import PropTypes from 'prop-types';
import { Flex, Box, Heading } from '@qga/roo-ui/components';

const PageSubHeader = ({ title, children }) => (
  <Box py={[1, 8]}>
    <Flex alignItems="start" justifyContent="space-between">
      <Heading.h2 fontWeight="normal" fontSize={['xl', '3xl']} my={[4, 0]} lineHeight="normal">
        {title}
      </Heading.h2>
      {children}
    </Flex>
  </Box>
);

PageSubHeader.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default PageSubHeader;
